import Intro from "@/pages/Intro";
import Main from "@/pages/Main";
import Mobile from "@/pages/Mobile";
import GamePlay from "@/pages/GamePlay";
import MGameListPage from "@/pages/MGameList";
import MGamePlay from "@/pages/MGamePlay";
import BetHistory from "@/pages/BetHistory";
import Lobby from "@/pages/Lobby";

const useRoutes = () => {
  const routeCollection = [
    { path: "/", component: Intro },
    { path: "/main", component: Main },
    { path: "/m", component: Mobile },
    { path: "/m/game-list/:menuCode", component: MGameListPage },
    { path: "/m/game-play/:vendor/:id/:currency", component: MGamePlay },
    { path: "/game-play/:vendor/:id/:currency", component: GamePlay },
    { path: "/bet-history", component: BetHistory },
    { path: "/lobby/:menuCode", component: Lobby },
  ];

  return {
    routeCollection,
  };
};

export default useRoutes;
